var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.181 11.623c1.228-.676 2.598-1.24 3.879-1.808a201.68 201.68 0 0 1 6.648-2.692c.434-.145 1.215-.287 1.292.357-.042.912-.214 1.819-.333 2.725-.3 1.993-.647 3.98-.986 5.966-.116.662-.945 1.005-1.476.581-1.274-.861-2.559-1.714-3.817-2.595-.412-.419-.03-1.02.338-1.32 1.05-1.034 2.163-1.913 3.158-3.001.269-.648-.524-.102-.786.065-1.437.99-2.84 2.042-4.355 2.912-.774.426-1.676.062-2.45-.176-.693-.287-1.71-.576-1.112-1.014Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.dd64536ebf4830f0a4f36e03323eed6e.svg";
export { ForwardRef as ReactComponent };